<script lang="ts" setup>
import type { MenuButtonLayout } from '@brighterly/lib-lumee-ui'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

import { useKidRoutes } from '@entities/customer'
import { useDisciplineInKid } from '@entities/customer'
import { useKidStore } from '@entities/customer'

import HeaderNavItem from './HeaderNavItem.vue'
import { useDisciplineLink } from './discipline-link.hook'

defineOptions({
  name: 'LinkDisciplineMath',
})

defineProps<{
  layout: MenuButtonLayout
}>()

const text = 'Math'

const kidStore = useKidStore()

const {
  homeMath,
  isRouteDisciplineMath,
} = useKidRoutes()

const { isDisciplineMath } = useDisciplineInKid()

const { discount, handleClick } = useDisciplineLink({
  discipline: Discipline.Math,
  isDiscipline: isDisciplineMath,
  isRouteDiscipline: isRouteDisciplineMath,
  homeRoute: homeMath,
  trackName: 'discipline_math',
  text,
})

</script>

<template>
  <HeaderNavItem
    :layout="layout"
    icon="ruler-triangle"
    :label="text"
    :href="homeMath ?? undefined"
    :selected="isRouteDisciplineMath"
    :disabled="!kidStore.hasActiveKid"
    :discount="discount"
    @click="handleClick"
  />
</template>
